import React, { useState } from "react";
import useAddIdsToUrl from "../../../utils/hooks/addIdsToUrl";
import useFacilityIds from "../../../utils/hooks/useFacilityIds";
import "./style.scss";
import DesktopNavBarButton from "../../../features/NavBar/features/DesktopNavBarButton";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useAuth from "../Login/hooks/useAuth";
import { LOGIN_PAGE } from "../../routes";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MobileFirstScreen: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { isLoggedIn } = useAuth();
  useFacilityIds();
  useAddIdsToUrl();

  const isActiveRoute = (link: string): boolean => {
    return location.pathname === link;
  };

  return (
    <React.Fragment>
      {saleConfiguration.componentList && (
        <div className="welcome-mobile">
          {saleConfiguration.componentList.map((item, index) => (
            <DesktopNavBarButton item={item} key={index} />
          ))}

          {saleConfiguration.allowToMakeAccount && (
            <Link to={LOGIN_PAGE}>
              {isLoggedIn ? (
                <button
                  className={
                    isActiveRoute(LOGIN_PAGE)
                      ? "button button-fill-main medium padding-medium"
                      : "button button-outline-main medium padding-medium"
                  }
                >
                  {t("moje_konto")}
                </button>
              ) : (
                <button
                  className={
                    isActiveRoute(LOGIN_PAGE)
                      ? "button button-fill-main medium padding-medium"
                      : "button button-outline-main medium padding-medium"
                  }
                >
                  {t("zaloguj_sie")}
                </button>
              )}
            </Link>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default MobileFirstScreen;
